import React from 'react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { isAuthenticated } from '@shared/utils/auth';

export const Route = createFileRoute('/_guest')({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
});
